import React, { useCallback, useState, FC } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { UseModalProps } from '../../../application/hooks/useModal';
import { DialogModal } from '../../dialogModal/dialogModal.component';
import Style from './issueDeleteDialog.module.css';

export type IssueDeleteFormParams = {
  issueId: number;
  callback: () => Promise<void>;
};

export const IssueDeleteDialog: FC<{
  modal: UseModalProps<IssueDeleteFormParams>;
}> = ({ modal }) => {
  const { t } = useTranslation();
  const [isApplying, setIsApplying] = useState(false);

  const { issueId, callback } = modal.params;

  const onApplyHandler = useCallback(async () => {
    try {
      setIsApplying(true);
      await callback();
    } catch (error) {
    } finally {
      modal.closeModal();
      setIsApplying(false);
    }
  }, [callback, modal]);

  return (
    <DialogModal
      visible={modal.visible}
      onHide={modal.closeModal}
      isDisabled={isApplying}
      testId={'delete-issue-modal'}
      footer={{
        leftButton: {
          type: 'reset',
          text: t('Common_Cancel'),
          onClick: modal.closeModal,
          disabled: isApplying,
        },
        rightButton: {
          colorSchema: 'destroy',
          text: t('Common_Delete'),
          onClick: onApplyHandler,
          disabled: isApplying,
        },
      }}
      title={t('Issues.DeleteModal.Title')}
    >
      <span>
        <Trans i18nKey={'Issues.DeleteModal.Text'} values={{ id: issueId }}>
          <span className={Style.mediumText} />
          <span className={Style.awfulText} />
        </Trans>
      </span>
    </DialogModal>
  );
};
